export class InterestRequest {
  propertyName: string;
  propertyRooms: number;
  propertyUrl: string;
  propertyAddress: string;
  propertyStart: string;
  propertyPms: string;
  propertyPmsName: string;

  contactName: string;
  contactRole: string;
  contactEmail: string;
  contactPhone: string;

  salesPerson: string;
  clientNotes: string;
  invoiceType: number;
  paymentState: number;

  termsAndConditionsApproved: boolean;
}



// WEBPACK FOOTER //
// /Users/linusvaltersson/AtomizeSource/clean_web/atomize-interest/src/app/model/interestRequest.ts